import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import AuditDetails from '../../elements/service/AuditDetails';
import SectionTitle from '../../elements/sectionTitle/SectionTitle';



const Login = () => {
    return (
        <>
            <SEO title="Audit and Accelerate Your Life, Business & Income" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* This is the Audit Details Page */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 w-75 mx-auto text-center">
                                {/* <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Audit and Accelerate Your Life, Business & Income"
                                    title='Here are 3 Areas on which you need clarity & powerful strategy to "Accelerate Your Life, Business & Income"'
                                // description = 
                                /> */}
                                <h5 style={{color:"#fb5343"}}>Audit and Accelerate Your Life, Business & Income</h5>
                                <h2>'Here are 3 Areas on which you need clarity & powerful strategy to "Accelerate Your Life, Business & Income"'</h2>
                            </div>
                        </div>
                        <AuditDetails
                            serviceStyle="service__style--1 bg-color-blackest radius mt--25"
                            textAlign="text-center"
                        />
                        {/* <div className="col-lg-12 w-100 text-center p-5 m-5">
                            <button className="btn-default btn-big">Purchase</button>
                        </div> */}

                    </div>
                </div>


                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Login
